module.exports = __webpack_public_path__ + "static/media/logo_fill.a255132e.svg";